import { Action, createReducer, on } from '@ngrx/store';
import { initialLogsState, ILogsState } from './logs.state';
import {
  LogsList,
  LogsListSuccess,
  LogsListError,
  LogsListPaginated,
  LogsListPaginatedSuccess,
  LogsListPaginatedError,
  LogGet,
  LogGetSuccess,
  LogGetError,
  LogDelete,
  LogDeleteSuccess,
  LogDeleteError,
  ResetLogsState
} from './logs.actions';

const logsReducerInternal = createReducer(
  initialLogsState,

  // Logs List
  on(LogsList, (state) => ({
    ...state,
    error: ''
  })),
  on(LogsListSuccess, (state, { logs }) => ({
    ...state,
    logs,
    error: ''
  })),
  on(LogsListError, (state, { error }) => ({
    ...state,
    error
  })),

  // Logs List Paginated
  on(LogsListPaginated, (state) => ({
    ...state,
    error: ''
  })),
  on(LogsListPaginatedSuccess, (state, { paginatedLogs }) => ({
    ...state,
    paginatedLogs,
    error: ''
  })),
  on(LogsListPaginatedError, (state, { error }) => ({
    ...state,
    error
  })),

  // Log Get
  on(LogGet, (state) => ({
    ...state,
    error: ''
  })),
  on(LogGetSuccess, (state, { log }) => ({
    ...state,
    log,
    error: ''
  })),
  on(LogGetError, (state, { error }) => ({
    ...state,
    error
  })),

  // Log Delete
  on(LogDelete, (state) => ({
    ...state,
    error: '',
    success: ''
  })),
  on(LogDeleteSuccess, (state, { success }) => ({
    ...state,
    success,
    error: ''
  })),
  on(LogDeleteError, (state, { error }) => ({
    ...state,
    error,
    success: ''
  })),

  // Reset State
  on(ResetLogsState, (state, { params }) => ({
    ...state,
    ...params
  }))
);

export function logsReducer(state: ILogsState | undefined, action: Action) {
  return logsReducerInternal(state, action);
}
